export default __webpack_public_path__ + "static/media/download_hover_toggle.d7e23a47.svg";